import React from 'react';

import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import Subscribe from '@app/components/UI/Subscribe/Subscribe';
import '@app/scss/components/EducationForm.scss';

const EducationForm: React.FC = () => {
	return <div className="subscribe">
		<div className="container text-center">
			<h2>
				Subscribe to learn about new posts
			</h2>
			<Subscribe
				type={0}
				buttonText="Subscribe"
			/>
		</div>
		<ImageLazy
			width={647}
			height={251}
			alt="Bubby"
			src="/images/Buddy14.png"
		/>
	</div>;
};

export default EducationForm;
